const getProductCategories = (productCategoriesCompound, page)=>{
    return productCategoriesCompound === null || productCategoriesCompound === void 0 ? void 0 : productCategoriesCompound.map(({ categoryTitle , description , imageLink , link , key  })=>{
        var ref;
        const imageObject = page.getContent(imageLink);
        var ref1;
        return {
            title: categoryTitle,
            description,
            image: {
                url: ((ref = imageObject === null || imageObject === void 0 ? void 0 : imageObject.getOriginal()) === null || ref === void 0 ? void 0 : ref.getUrl()) || '',
                description: (ref1 = imageObject === null || imageObject === void 0 ? void 0 : imageObject.getDescription()) !== null && ref1 !== void 0 ? ref1 : null
            },
            key,
            link: link === null || link === void 0 ? void 0 : link.url
        };
    });
};

export { getProductCategories };
//# sourceMappingURL=get-product-categories.js.map
